import chroma from "chroma-js";

const MuiButton: any = {
  styleOverrides: {
    containedSuccess: {
      color: "#FFF",
    },
    containedWarning: {
      color: "#FFF",
    },
    containedDev: {
      color: "#FFF",
    },
  },
};

export default MuiButton;
